import { Button, Tabs, Tooltip } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAppSelector } from '../../Reducers/store';
import { HiPencilAlt } from 'react-icons/hi';
import ClientApi from '../../Api/ClientApi';
import { Client } from '../../Models/Client';
import { toast } from 'react-toastify';
import { UserLevelNames } from '../../Models/UserLevel';
import ClientLocationList from './ClientLocationList';
import ClientContactList from './Contact/ClientContactList';
import ClientInventoryMarkUpList from './MarkUp/ClientInventoryMarkUpList';
import ClientJobList from './Job/ClientJobList';

export default function ClientProfile() {
  const { userModel } = useAppSelector((state) => state.user);
  const { id } = useParams();
  const [clientData, setClientData] = useState<Client | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLinkingQuickBooks, setIsLinkingQuickBooks] = useState<boolean>(false);

  const getClient = () => {
    if (id) {
      setIsLoading(true);
      ClientApi.getClient(id)
        .then((res) => {
          setClientData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setClientData(null);
    }
  };

  useEffect(() => {
    getClient();
  }, [id]);

  const iconstyle = { color: '#f9ed33' };

  function checkAccess() {
    if (clientData && userModel && id) {
      return true;
      // if (userModel.userLevelId === UserLevelNames.SuperAdmin) {
      //   return true;
      // } else if (
      //   userModel.memberId === clientData.memberId &&
      //   userModel.id === Number(id)
      // ) {
      //   return true;
      // } else if (
      //   userModel.memberId === clientData.memberId &&
      //   userModel.userLevelId === UserLevelNames.MemberAdmin
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
    }
    return false;
  }

  const canManageQuickBooks =
    userModel?.userLevelId === UserLevelNames.Admin ||
    userModel?.userLevelId === UserLevelNames.SuperAdmin;

  const handleCreateQuickBooksCustomer = async () => {
    if (!clientData?.id) return;
    try {
      setIsLinkingQuickBooks(true);
      const res = await ClientApi.createOrLinkQuickBooksCustomer(clientData.id);
      if (res.data.success) {
        toast.success('QuickBooks customer linked');
        getClient();
      } else {
        toast.error(res.data.message || 'Failed to link QuickBooks customer');
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to link QuickBooks customer');
    } finally {
      setIsLinkingQuickBooks(false);
    }
  };

  return (
    <div className='w-full'>
      <div className='w-full p-4'>
        <div className='mx-1 flex items-end'>
          <div className='flex flex-1'>
            <h1 className='text-gray-900 font-bold text-4xl'>
              Client Information
            </h1>
          </div>
          {checkAccess() && (
            <div className='right-2'>
              <Link to={`/client/edit/${clientData?.id}`}>
                <Tooltip content='Edit'>
                  <Button className='buttonMain'>
                    <HiPencilAlt size={20} />
                  </Button>
                </Tooltip>
              </Link>
            </div>
          )}
        </div>
      </div>

      <div>
        <div className='container mx-auto p-2'>
          <div className='md:flex no-wrap md:-mx-2 '>
            {/* <div className='w-full md:w-2/12 md:mx-2'>
              <div className='h-72 overflow-hidden rounded-md'>
                <img src={clientData?.image?.url ?? blankImage} alt='...' />
              </div>
            </div> */}
            <div className='w-full mx-2'>
              <div className='bg-white p-3'>
                <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2'>
                  <span className='tracking-wide uppercase text-3xl'>
                    {clientData?.name}
                  </span>
                </div>
                <hr className='bg-gray-200 h-[5px]'></hr>
                <div className='text-gray-500'>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Name:</div>
                    </div>
                    <div className='pl-1 text-black'>{clientData?.name}</div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Account #:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {clientData?.accountNumber}
                    </div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='font-bold content-center'>Type:</div>
                    <div className='pl-1 text-black'>
                      {clientData?.clientType?.name}
                    </div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>
                        Market Segment:
                      </div>
                    </div>
                    <div className='pl-1 text-black'>
                      {clientData?.marketSubSegmentId}
                    </div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Email:</div>
                    </div>
                    <div className='pl-1 text-black'>{clientData?.email}</div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Phone:</div>
                    </div>
                    <div className='pl-1 text-black'>{clientData?.phone}</div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Address:</div>
                    </div>
                    <div className='flex flex-col'>
                      <div className='pl-1 text-black'>
                        {clientData?.address}
                      </div>
                      <div className='w-full flex'>
                        <div className='pl-1 text-black'>
                          {clientData?.city}
                          {clientData?.city && ','}{' '}
                        </div>
                        <div className='pl-1 text-black'>
                          {clientData?.state?.code}{' '}
                        </div>
                        <div className='pl-1 text-black'>{clientData?.zip}</div>
                      </div>
                      <div className='pl-1 text-black'>
                        {clientData?.country?.name}
                      </div>
                    </div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>Website:</div>
                    </div>
                    <div className='pl-1 text-black'>{clientData?.website}</div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='flex'>
                      <div className='font-bold content-center'>
                        Quickbooks Id:
                      </div>
                    </div>
                    <div className='pl-1 text-black flex items-center gap-2'>
                      <div>{clientData?.quickbooksId || '(Not linked)'}</div>
                      {canManageQuickBooks && !clientData?.quickbooksId && (
                        <Button
                          size='xs'
                          className='buttonMain'
                          onClick={handleCreateQuickBooksCustomer}
                          disabled={isLinkingQuickBooks}
                        >
                          {isLinkingQuickBooks
                            ? 'Linking...'
                            : 'Create in QuickBooks'}
                        </Button>
                      )}
                    </div>
                  </div>
                  <hr className='bg-gray-200 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] lg:grid-cols-[25%_75%] text-sm md:text-xl'>
                    <div className='font-bold content-center'>Description:</div>
                    <div>
                      <div className='pl-1 text-black'>
                        {clientData?.description}
                      </div>
                    </div>
                  </div>
                </div>
                <Tabs style='fullWidth' className='mt-2'>
                  <Tabs.Item title='Contacts' className='font-bold'>
                    {id && <ClientContactList clientId={Number(id)} />}
                  </Tabs.Item>
                  <Tabs.Item title='Locations' className='font-bold'>
                    {id && <ClientLocationList clientId={Number(id)} />}
                  </Tabs.Item>
                  <Tabs.Item title='Mark Ups' className='font-bold'>
                    {id && <ClientInventoryMarkUpList clientId={Number(id)} />}
                  </Tabs.Item>
                  <Tabs.Item title='Jobs' className='font-bold'>
                    {id && <ClientJobList clientId={Number(id)} />}
                  </Tabs.Item>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
